import get from 'lodash/get';

import i18n from 'shared/lib/i18n';

import {
  ACCESS_POINT_CREATE_FAILURE,
  ACCESS_POINT_CREATE_SUCCEEDED,
  ACCESS_POINT_UPDATE_FAILURE,
  ACCESS_POINT_UPDATE_SUCCEEDED,
  ADD_MESSAGE_SELLER_FAILURE,
  ADD_MESSAGE_SELLER_SUCCESS,
  ADD_PAYMENT_PROVIDER_SUCCESS,
  ADD_RSVP_GUEST_FAILURE,
  ADD_RSVP_GUEST_SUCCESS,
  ADMIN_CREATE_REQUESTED,
  ADMIN_INVITE_RESENT,
  ADMIN_REMOVE_REQUESTED,
  ADMIN_UPDATE_REQUESTED,
  ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_FAILURE,
  ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_SUCCESS,
  ASSIGN_EE_ACCOUNT_TO_BUILDING_FAILURE,
  ASSIGN_EE_ACCOUNT_TO_BUILDING_SUCCESS,
  ASSIGN_MRI_ACCOUNT_TO_BUILDING_FAILURE,
  ASSIGN_MRI_ACCOUNT_TO_BUILDING_SUCCESS,
  ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_FAILURE,
  ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_SUCCESS,
  ASSIGN_YARDI_ACCOUNT_TO_BUILDING_FAILURE,
  ASSIGN_YARDI_ACCOUNT_TO_BUILDING_SUCCESS,
  ASSOCIATE_2N_WITH_BUILDING_FAILURE,
  ASSOCIATE_2N_WITH_BUILDING_SUCCESS,
  ASSOCIATE_BMX_WITH_BUILDING_FAILURE,
  ASSOCIATE_BMX_WITH_BUILDING_SUCCESS,
  ASSOCIATE_BRIVO_WITH_BUILDING_FAILURE,
  ASSOCIATE_BRIVO_WITH_BUILDING_SUCCESS,
  ASSOCIATE_COMELIT_WITH_BUILDING_FAILURE,
  ASSOCIATE_COMELIT_WITH_BUILDING_SUCCESS,
  ASSOCIATE_DORMAKABA_WITH_BUILDING_FAILURE,
  ASSOCIATE_DORMAKABA_WITH_BUILDING_SUCCESS,
  ASSOCIATE_KEYSCAN_WITH_BUILDING_FAILURE,
  ASSOCIATE_KEYSCAN_WITH_BUILDING_SUCCESS,
  ASSOCIATE_LYAZON_WITH_BUILDING_FAILURE,
  ASSOCIATE_LYAZON_WITH_BUILDING_SUCCESS,
  ASSOCIATE_SALTO_WITH_BUILDING_FAILURE,
  ASSOCIATE_SALTO_WITH_BUILDING_SUCCESS,
  ASSOCIATE_SMARTAIR_WITH_BUILDING_FAILURE,
  ASSOCIATE_SMARTAIR_WITH_BUILDING_SUCCESS,
  ASSOCIATE_ZERV_WITH_BUILDING_FAILURE,
  ASSOCIATE_ZERV_WITH_BUILDING_SUCCESS,
  AUTH_SET_PASSWORD,
  BAN_MEMBER_FAILURE,
  BAN_MEMBER_SUCCESS,
  BUILDING_CREATE_FAILURE,
  BUILDING_CREATE_SUCCEEDED,
  BUILDING_DELETE_FAILURE,
  BUILDING_DELETE_SUCCESS,
  BUILDING_UPDATE_FAILURE,
  BUILDING_UPDATE_SUCCEEDED,
  CALL_CENTER_NO_ACTION,
  CAMERAS_REORDER_SUCCESS,
  CAMERA_UPDATE_REQUESTED,
  CHECK_DOCUMENT_EXISTING_THREAD_FAILURE,
  CHECK_DOCUMENT_FAILURE,
  CHECK_DOCUMENT_NEW_THREAD_FAILURE,
  CLEAR_BRIVO_USERS_FAILURE,
  CLEAR_BRIVO_USERS_SUCCESS,
  CLEAR_POPUP,
  COMMUNITY_OPT_IN_OUT_FAILURE,
  COMMUNITY_OPT_IN_OUT_SUCCESS,
  COMMUNITY_THREAD_EXISTS_FAILURE,
  CREATE_ACCESS_CARD_FAILURE,
  CREATE_ACCESS_CARD_SUCCESS,
  CREATE_AMENITY_FAILURE,
  CREATE_AMENITY_SUCCESS,
  CREATE_ANNOUNCEMENT_FAILURE,
  CREATE_ANNOUNCEMENT_SUCCESS,
  CREATE_BUILDING_GUIDE_CARD_FAILURE,
  CREATE_BUILDING_GUIDE_CARD_SUCCESS,
  CREATE_CALL_CENTER_AGENT_FAILURE,
  CREATE_CALL_CENTER_AGENT_SUCCESS,
  CREATE_CAMERA_FAILURE,
  CREATE_CAMERA_SUCCESS,
  CREATE_COURIER_ERROR_FAILURE,
  CREATE_COURIER_ERROR_SUCCESS,
  CREATE_DELIVERY_FAILURE,
  CREATE_DELIVERY_SUCCESS,
  CREATE_DELIVERY_TYPE_FAILURE,
  CREATE_DELIVERY_TYPE_SUCCESS,
  CREATE_DIRECTORY_FAILURE,
  CREATE_DIRECTORY_SUCCESS,
  CREATE_EVENT_FAILURE,
  CREATE_EVENT_SUCCESS,
  CREATE_EXTERNAL_ACCOUNT_FAILURE,
  CREATE_EXTERNAL_ACCOUNT_SUCCESS,
  CREATE_HOME_FEED_CARD_FAILURE,
  CREATE_HOME_FEED_CARD_SUCCESS,
  CREATE_POP_UP_FAILURE,
  CREATE_POP_UP_SUCCESS,
  CREATE_POST_COMMENT_FAILURE,
  CREATE_POST_COMMENT_SUCCESS,
  CREATE_RSVP_FAILURE,
  CREATE_RSVP_SUCCESS,
  CREATE_SERVICE_REQUEST_FAILURE,
  CREATE_SERVICE_REQUEST_SUCCESS,
  CREATE_STAFF_LOG_COMMENT_FAILURE,
  CREATE_STAFF_LOG_COMMENT_SUCCESS,
  CREATE_STAFF_LOG_POST_FAILURE,
  CREATE_STAFF_LOG_POST_SUCCESS,
  CREATE_THREAD_FAILURE,
  CREATE_UNITS_FAILURE,
  CREATE_UNITS_SUCCESS,
  DELETE_ACCESS_CARD_FAILURE,
  DELETE_ACCESS_CARD_SUCCESS,
  DELETE_AMENITY_IMAGE_FAILURE,
  DELETE_ANNOUNCEMENT_FAILURE,
  DELETE_ANNOUNCEMENT_SUCCESS,
  DELETE_BUILDING_GUIDE_CARD_FAILURE,
  DELETE_BUILDING_GUIDE_CARD_SUCCESS,
  DELETE_CALL_CENTER_AGENT_FAILURE,
  DELETE_CAMERA_FAILURE,
  DELETE_CAMERA_SUCCESS,
  DELETE_DIRECTORY_FAILURE,
  DELETE_DIRECTORY_SUCCESS,
  DELETE_EVENT_FAILURE,
  DELETE_EVENT_RSVP_FAILURE,
  DELETE_EVENT_RSVP_GUEST_FAILURE,
  DELETE_EVENT_RSVP_GUEST_SUCCESS,
  DELETE_EVENT_RSVP_SUCCESS,
  DELETE_EVENT_SUCCESS,
  DELETE_EXTERNAL_ACCOUNT_FAILURE,
  DELETE_EXTERNAL_ACCOUNT_SUCCESS,
  DELETE_FILE_FAILURE,
  DELETE_FILE_SUCCESS,
  DELETE_HOME_FEED_CARD_FAILURE,
  DELETE_HOME_FEED_CARD_SUCCESS,
  DELETE_LOGO_FAILURE,
  DELETE_LOGO_SUCCESS,
  DELETE_PICTURE_FAILURE,
  DELETE_PICTURE_SUCCESS,
  DELETE_PMC_FAILURE,
  DELETE_PMC_SUCCESS,
  DELETE_POP_UP_FAILURE,
  DELETE_POP_UP_PHOTO_FAILURE,
  DELETE_POP_UP_SUCCESS,
  DELIVERIES_SIGN_OUT_FAILURE,
  DELIVERIES_SIGN_OUT_SUCCESS,
  DOORS_REORDER_SUCCESS,
  DOOR_CREATE_FAILURE,
  DOOR_CREATE_SUCCEEDED,
  DOOR_DELETE_FAILURE,
  DOOR_DELETE_SUCCESS,
  DOOR_UPDATE_FAILURE,
  DOOR_UPDATE_SUCCEEDED,
  EXCHANGE_TOKEN_FAILURE,
  EXPIRE_VISITORS_FAILURE,
  EXPIRE_VISITORS_SUCCEEDED,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCEEDED,
  GET_BMX_ACCESS_TOKEN_FAILURE,
  GET_BMX_REGISTRATION_STATUS_FAILURE,
  GET_BUILDING_BRIVO_SITE_ID_FAILURE,
  GET_CHATS_FAILURE,
  GET_CHAT_BY_ID_FAILURE,
  GET_COMMUNITY_CHAT_BY_ID_FAILURE,
  GET_COMMUNITY_MEMBERS_LIST_FAILURE,
  GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_FAILURE,
  GET_DETAILED_FD_RESERVATIONS_FAILURE,
  GET_DOCUMENT_FAILURE,
  GET_FD_EVENTS_FAILURE,
  GET_FD_RESERVATIONS_FAILURE,
  GET_NUMBER_OF_RECIPIENTS_FAILURE,
  GET_POSTS_COMMENTS_LIST_FAILURE,
  GET_POSTS_LIST_FAILURE,
  GET_POST_BY_ID_FAILURE,
  GET_QR_CODE_FAILURE,
  GET_RECIPIENTS_FAILURE,
  GET_ROLES_FAILURE,
  GET_STAFF_LOG_COMMENTS_LIST_FAILURE,
  GET_TWILIO_TOKEN_FAILURE,
  GET_YARDI_STATUSES_FAILURE,
  GET_YARDI_UNITS_FAILURE,
  IP_CREATE_REQUESTED,
  IP_DELETE_REQUESTED,
  IP_UPDATE_REQUESTED,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOG_VISITOR_ENTRY_FAILURE,
  LOG_VISITOR_ENTRY_SUCCESS,
  MANAGE_CREDENTIALS_FAILURE,
  MANAGE_CREDENTIALS_SUCCESS,
  MARK_CHAT_AS_READ_FAILURE,
  MODIFY_BUILDING_EXTERNAL_LINKS_FAILURE,
  MODIFY_BUILDING_EXTERNAL_LINKS_SUCCESS,
  MODIFY_BUILDING_EXTERNAL_LINK_FAILURE,
  NOTIFY_SUCCESS,
  NOTIFY_WARNING,
  ON_DOOR_SCHEDULE_CHANGE_FAILURE,
  OPEN_DOOR,
  PERSON_INVITE_RESENT,
  PMC_CREATE_FAILURE,
  PMC_CREATE_SUCCESS,
  PMC_UPDATE_FAILURE,
  PMC_UPDATE_SUCCESS,
  PRELOAD_DOCUMENT_FAILURE,
  PRELOAD_DOCUMENT_SUCCESS,
  PUT_BUILDING_DELIVERY_TYPES_FAILURE,
  PUT_BUILDING_DELIVERY_TYPES_SUCCESS,
  PUT_BUILDING_SETTINGS_FAILURE,
  PUT_BUILDING_SETTINGS_SUCCESS,
  PUT_INTEGRATIONS_STATUS_FAILURE,
  PUT_INTEGRATIONS_STATUS_SUCCESS,
  PUT_LEASING_SETTINGS_FAILURE,
  PUT_LEASING_SETTINGS_SUCCESS,
  PUT_NEW_MESSAGE_FAILURE,
  PUT_PROPERTY_SETTINGS_FAILURE,
  PUT_PROPERTY_SETTINGS_SUCCESS,
  PUT_REMOTE_DOORMAN_SETTINGS_FAILURE,
  PUT_REMOTE_DOORMAN_SETTINGS_SUCCESS,
  REMOVE_ACCOUNTING_ACCOUNT_FAILURE,
  REMOVE_ACCOUNTING_ACCOUNT_SUCCESS,
  REMOVE_AC_ACCOUNT_FAILURE,
  REMOVE_AC_ACCOUNT_SUCCESS,
  REMOVE_AMENITY_FAILURE,
  REMOVE_AMENITY_SUCCESS,
  REMOVE_COMMENT_FAILURE,
  REMOVE_COMMENT_SUCCESS,
  REMOVE_DELIVERY_TYPE_FAILURE,
  REMOVE_DELIVERY_TYPE_SUCCESS,
  REMOVE_POST_FAILURE,
  REMOVE_POST_SUCCESS,
  REMOVE_RESERVATION_FAILURE,
  REMOVE_RESERVATION_SUCCESS,
  REMOVE_STAFF_LOG_COMMENT_FAILURE,
  REMOVE_STAFF_LOG_COMMENT_SUCCESS,
  REMOVE_STAFF_LOG_POST_FAILURE,
  REMOVE_STAFF_LOG_POST_SUCCESS,
  RESEND_BMX_INVITE_FAILURE,
  RESEND_BMX_INVITE_SUCCESS,
  RESEND_INVITE_TO_ALL_RESIDENTS_FAILURE,
  RESEND_INVITE_TO_ALL_RESIDENTS_SUCCESS,
  RESERVE_AMENITY_FAILURE,
  RESERVE_AMENITY_SUCCESS,
  RESIDENT_CREATE_FAILURE,
  RESIDENT_CREATE_SUCCESS,
  RESIDENT_MOVE_OUT_FAILURE,
  RESIDENT_MOVE_OUT_SUCCESS,
  RESIDENT_UPDATE_FAILURE,
  RESIDENT_UPDATE_SUCCESS,
  SEND_ANNOUNCEMENT_FAILURE,
  SEND_ANNOUNCEMENT_SUCCESS,
  SEND_STATISTICS_FAILURE,
  SEND_STATISTICS_SUCCESS,
  SERVICE_REQUEST_UPDATE_REQUESTED,
  SET_AMENITY_STATUS_FAILURE,
  SET_AMENITY_STATUS_SUCCESS,
  SET_NEW_VISITOR_FAILURE,
  SET_NEW_VISITOR_SUCCEEDED,
  SET_SKIP_MOVE_IN_FAILURE,
  SET_SKIP_MOVE_IN_SUCCESS,
  SIGNUP_FAILURE,
  SOCIAL_SIGNUP_FAILURE,
  SR_CATEGORIES_CREATE_FAILURE,
  SR_CATEGORIES_CREATE_SUCCESS,
  SR_CATEGORIES_DELETE_FAILURE,
  SR_CATEGORIES_DELETE_SUCCESS,
  SR_CATEGORIES_UPDATE_FAILURE,
  SR_CATEGORIES_UPDATE_SUCCESS,
  STAFF_CREATE_REQUESTED,
  STAFF_MOVE_OUT_SUCCESS,
  STAFF_UPDATE_REQUESTED,
  SUBMIT_LEASING_MESSAGE_FAILURE,
  SUBMIT_LEASING_MESSAGE_SUCCESS,
  SUBMIT_POST_FAILURE,
  SUBMIT_POST_SUCCESS,
  SYNC_ALL_PERSONS_WITH_BMX_FAILURE,
  SYNC_ALL_PERSONS_WITH_BMX_SUCCESS,
  SYNC_BMX_DOORS_FAILURE,
  SYNC_BMX_DOORS_SUCCESS,
  SYNC_BMX_PERSONS_FAILURE,
  SYNC_BMX_PERSONS_SUCCESS,
  SYNC_DEVICES_FAILURE,
  SYNC_DEVICES_SUCCESS,
  SYNC_DORMAKABA_FAILURE,
  SYNC_DORMAKABA_SUCCESS,
  SYNC_PERSONS_FAILURE,
  SYNC_PERSONS_SUCCESS,
  SYNC_PERSON_FAILURE,
  SYNC_PERSON_SUCCESS,
  SYNC_PERSON_WITH_BMX_FAILURE,
  SYNC_PERSON_WITH_BMX_SUCCESS,
  SYNC_PERSON_WITH_BRIVO_FAILURE,
  SYNC_PERSON_WITH_BRIVO_SUCCEEDED,
  SYNC_PERSON_WITH_SMARTAIR,
  SYNC_RESIDENTS_FROM_YARDI_FAILURE,
  SYNC_RESIDENTS_FROM_YARDI_SUCCESS,
  SYNC_YARDI_SR_AND_RESIDENTS_FAILURE,
  SYNC_YARDI_SR_AND_RESIDENTS_SUCCESS,
  SYNC_YARDI_SR_CATEGORIES_FAILURE,
  TOGGLE_LOGO_DISABLED_FAILURE,
  TOGGLE_LOGO_DISABLED_SUCCESS,
  TOGGLE_POST_LIKE_FAILURE,
  UNITS_ORDERING_SUBMITTED,
  UNIT_REMOVE_SUCCEEDED,
  UPDATE_ACCESS_CARD_FAILURE,
  UPDATE_ACCESS_CARD_SUCCESS,
  UPDATE_ACCOUNTING_ACCOUNT_FAILURE,
  UPDATE_AMENITY_FAILURE,
  UPDATE_AMENITY_RESERVATION_FAILURE,
  UPDATE_AMENITY_RESERVATION_SUCCESS,
  UPDATE_AMENITY_SUCCESS,
  UPDATE_ANNOUNCEMENT_FAILURE,
  UPDATE_ANNOUNCEMENT_SUCCESS,
  UPDATE_BUILDING_GUIDE_CARD_FAILURE,
  UPDATE_BUILDING_GUIDE_CARD_SUCCESS,
  UPDATE_BUILDING_OPERATIONS_FAILURE,
  UPDATE_BUILDING_OPERATIONS_SUCCESS,
  UPDATE_COMMUNITY_FAILURE,
  UPDATE_COMMUNITY_ITEM_STATUS_FAILURE,
  UPDATE_COMMUNITY_ITEM_STATUS_SUCCESS,
  UPDATE_CURRENT_PERSON,
  UPDATE_DELIVERY_FAILURE,
  UPDATE_DELIVERY_SUCCESS,
  UPDATE_DELIVERY_TYPE_FAILURE,
  UPDATE_DELIVERY_TYPE_SUCCESS,
  UPDATE_DIRECTORY_FAILURE,
  UPDATE_DIRECTORY_SUCCESS,
  UPDATE_EVENT_FAILURE,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EXTERNAL_ACCOUNT_FAILURE,
  UPDATE_EXTERNAL_ACCOUNT_SUCCESS,
  UPDATE_HOME_FEED_CARD_FAILURE,
  UPDATE_HOME_FEED_CARD_SUCCESS,
  UPDATE_INVITE_INFO_FAILURE,
  UPDATE_INVITE_INFO_SUCCESS,
  UPDATE_NEW_VISITOR_FAILURE,
  UPDATE_NEW_VISITOR_SUCCEEDED,
  UPDATE_POP_UP_FAILURE,
  UPDATE_POP_UP_SUCCESS,
  UPDATE_RD_DOORS_FAILURE,
  UPDATE_ROLE_FAILURE,
  UPDATE_UNIT_FAILURE,
  UPDATE_VISITOR_KEYS_DATA_SUCCESS,
  UPLOAD_FILES_FAILURE,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE_SUCCESS,
  VALIDATE_ACCESS_CARD_FAILURE,
  VALIDATE_ADDRESS_FAILURE,
  VERIFY_FAILURE,
  VERIFY_PHONE_NUMBER_FAILURE,
  VERIFY_SUCCESS,
  VISITOR_CREATE_SUBMITTED,
  VISITOR_INVITE_DELETE,
  VISITOR_INVITE_RESEND,
  VISITOR_INVITE_SEND,
  VISITOR_REJECT_SUBMITTED,
  WIPE_PERSON_DATA_FAILURE,
  WIPE_PERSON_DATA_SUCCESS,
  YARDI_RESYNC_REQUESTED,
} from '../actionConstants';

const defaultState = {
  error: null,
  apiError: null,
  warning: null,
  success: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case CLEAR_POPUP: {
      return defaultState;
    }
    case NOTIFY_SUCCESS:
      return {
        ...state,
        success: { msg: action.message },
      };
    case NOTIFY_WARNING:
      return {
        ...state,
        warning: { msg: action.message },
      };
    case BUILDING_DELETE_SUCCESS:
    case UNIT_REMOVE_SUCCEEDED:
    case STAFF_UPDATE_REQUESTED:
    case STAFF_MOVE_OUT_SUCCESS:
    case RESIDENT_UPDATE_SUCCESS:
    case RESIDENT_MOVE_OUT_SUCCESS:
    case PMC_UPDATE_SUCCESS:
    case PMC_CREATE_SUCCESS:
    case DELETE_PMC_SUCCESS:
    case IP_UPDATE_REQUESTED:
    case IP_DELETE_REQUESTED:
    case IP_CREATE_REQUESTED:
    case OPEN_DOOR:
    case AUTH_SET_PASSWORD:
    case FORGOT_PASSWORD_SUCCEEDED:
    case UPDATE_CURRENT_PERSON:
    case ADMIN_UPDATE_REQUESTED:
    case UNITS_ORDERING_SUBMITTED:
    case ADMIN_REMOVE_REQUESTED:
    case LOGIN_SUCCESS:
    case ADMIN_CREATE_REQUESTED:
    case BUILDING_CREATE_SUCCEEDED:
    case BUILDING_UPDATE_SUCCEEDED:
    case CREATE_DELIVERY_SUCCESS:
    case VISITOR_CREATE_SUBMITTED:
    case VISITOR_REJECT_SUBMITTED:
    case CREATE_CAMERA_SUCCESS:
    case DELETE_CAMERA_SUCCESS:
    case CAMERA_UPDATE_REQUESTED:
    case SERVICE_REQUEST_UPDATE_REQUESTED:
    case CREATE_SERVICE_REQUEST_SUCCESS:
    case ACCESS_POINT_UPDATE_SUCCEEDED:
    case ACCESS_POINT_CREATE_SUCCEEDED:
    case DOOR_UPDATE_SUCCEEDED:
    case DOOR_CREATE_SUCCEEDED:
    case CALL_CENTER_NO_ACTION:
    case UPLOAD_FILES_SUCCESS:
    case SYNC_PERSON_WITH_BRIVO_SUCCEEDED:
    case SYNC_PERSON_WITH_SMARTAIR:
    case YARDI_RESYNC_REQUESTED:
    case SR_CATEGORIES_UPDATE_SUCCESS:
    case SR_CATEGORIES_CREATE_SUCCESS:
    case SR_CATEGORIES_DELETE_SUCCESS:
    case SET_NEW_VISITOR_SUCCEEDED:
    case UPDATE_NEW_VISITOR_SUCCEEDED:
    case VISITOR_INVITE_RESEND:
    case VISITOR_INVITE_SEND:
    case VISITOR_INVITE_DELETE:
    case EXPIRE_VISITORS_SUCCEEDED:
    case UPDATE_VISITOR_KEYS_DATA_SUCCESS:
    case CREATE_DIRECTORY_SUCCESS:
    case UPDATE_DIRECTORY_SUCCESS:
    case UPLOAD_FILE_SUCCESS:
    case DELETE_DIRECTORY_SUCCESS:
    case DELETE_FILE_SUCCESS:
    case CAMERAS_REORDER_SUCCESS:
    case DOORS_REORDER_SUCCESS:
    case RESEND_INVITE_TO_ALL_RESIDENTS_SUCCESS:
    case UPDATE_INVITE_INFO_SUCCESS:
    case PUT_BUILDING_SETTINGS_SUCCESS:
    case ASSOCIATE_BRIVO_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_SMARTAIR_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_COMELIT_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_2N_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_BMX_WITH_BUILDING_SUCCESS:
    case ASSIGN_YARDI_ACCOUNT_TO_BUILDING_SUCCESS:
    case ASSIGN_MRI_ACCOUNT_TO_BUILDING_SUCCESS:
    case ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_SUCCESS:
    case ASSIGN_EE_ACCOUNT_TO_BUILDING_SUCCESS:
    case ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_SUCCESS:
    case REMOVE_ACCOUNTING_ACCOUNT_SUCCESS:
    case REMOVE_AC_ACCOUNT_SUCCESS:
    case CREATE_EXTERNAL_ACCOUNT_SUCCESS:
    case UPDATE_EXTERNAL_ACCOUNT_SUCCESS:
    case DELETE_EXTERNAL_ACCOUNT_SUCCESS:
    case RESIDENT_CREATE_SUCCESS:
    case ADD_PAYMENT_PROVIDER_SUCCESS:
    case SYNC_BMX_DOORS_SUCCESS:
    case SYNC_PERSON_WITH_BMX_SUCCESS:
    case SYNC_ALL_PERSONS_WITH_BMX_SUCCESS:
    case SYNC_RESIDENTS_FROM_YARDI_SUCCESS:
    case SYNC_BMX_PERSONS_SUCCESS:
    case SYNC_DEVICES_SUCCESS:
    case SYNC_PERSONS_SUCCESS:
    case SYNC_PERSON_SUCCESS:
    case VERIFY_SUCCESS:
    case PRELOAD_DOCUMENT_SUCCESS:
    case PUT_INTEGRATIONS_STATUS_SUCCESS:
    case RESEND_BMX_INVITE_SUCCESS:
    case PUT_BUILDING_DELIVERY_TYPES_SUCCESS:
    case CREATE_DELIVERY_TYPE_SUCCESS:
    case UPDATE_DELIVERY_TYPE_SUCCESS:
    case REMOVE_DELIVERY_TYPE_SUCCESS:
    case DELETE_ACCESS_CARD_SUCCESS:
    case UPDATE_ACCESS_CARD_SUCCESS:
    case CREATE_ACCESS_CARD_SUCCESS:
    case SEND_STATISTICS_SUCCESS:
    case SET_SKIP_MOVE_IN_SUCCESS:
    case SUBMIT_LEASING_MESSAGE_SUCCESS:
    case RESERVE_AMENITY_SUCCESS:
    case CREATE_AMENITY_SUCCESS:
    case UPDATE_AMENITY_SUCCESS:
    case REMOVE_RESERVATION_SUCCESS:
    case UPDATE_AMENITY_RESERVATION_SUCCESS:
    case REMOVE_AMENITY_SUCCESS:
    case WIPE_PERSON_DATA_SUCCESS:
    case MANAGE_CREDENTIALS_SUCCESS:
    case ASSOCIATE_DORMAKABA_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_KEYSCAN_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_LYAZON_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_ZERV_WITH_BUILDING_SUCCESS:
    case ASSOCIATE_SALTO_WITH_BUILDING_SUCCESS:
    case CLEAR_BRIVO_USERS_SUCCESS:
    case LOG_VISITOR_ENTRY_SUCCESS:
    case CREATE_ANNOUNCEMENT_SUCCESS:
    case UPDATE_ANNOUNCEMENT_SUCCESS:
    case DELETE_ANNOUNCEMENT_SUCCESS:
    case SEND_ANNOUNCEMENT_SUCCESS:
    case PUT_PROPERTY_SETTINGS_SUCCESS:
    case PUT_LEASING_SETTINGS_SUCCESS:
    case PUT_REMOTE_DOORMAN_SETTINGS_SUCCESS:
    case TOGGLE_LOGO_DISABLED_SUCCESS:
    case DELETE_LOGO_SUCCESS:
    case DOOR_DELETE_SUCCESS:
    case SYNC_DORMAKABA_SUCCESS:
    case UPDATE_BUILDING_OPERATIONS_SUCCESS:
    case DELETE_PICTURE_SUCCESS:
    case CREATE_CALL_CENTER_AGENT_SUCCESS:
    case MODIFY_BUILDING_EXTERNAL_LINKS_SUCCESS:
    case CREATE_POP_UP_SUCCESS:
    case UPDATE_POP_UP_SUCCESS:
    case DELETE_POP_UP_SUCCESS:
    case REMOVE_POST_SUCCESS:
    case SUBMIT_POST_SUCCESS:
    case ADD_MESSAGE_SELLER_SUCCESS:
    case CREATE_POST_COMMENT_SUCCESS:
    case DELIVERIES_SIGN_OUT_SUCCESS:
    case CREATE_COURIER_ERROR_SUCCESS:
    case COMMUNITY_OPT_IN_OUT_SUCCESS:
    case UPDATE_DELIVERY_SUCCESS:
    case CREATE_STAFF_LOG_POST_SUCCESS:
    case REMOVE_STAFF_LOG_POST_SUCCESS:
    case CREATE_STAFF_LOG_COMMENT_SUCCESS:
    case REMOVE_STAFF_LOG_COMMENT_SUCCESS:
    case SET_AMENITY_STATUS_SUCCESS:
    case CREATE_UNITS_SUCCESS:
    case SYNC_YARDI_SR_AND_RESIDENTS_SUCCESS:
    case UPDATE_COMMUNITY_ITEM_STATUS_SUCCESS:
    case BAN_MEMBER_SUCCESS:
    case REMOVE_COMMENT_SUCCESS:
    case CREATE_EVENT_SUCCESS:
    case UPDATE_EVENT_SUCCESS:
    case DELETE_EVENT_SUCCESS:
    case DELETE_EVENT_RSVP_SUCCESS:
    case DELETE_EVENT_RSVP_GUEST_SUCCESS:
    case CREATE_RSVP_SUCCESS:
    case ADD_RSVP_GUEST_SUCCESS:
    case CREATE_HOME_FEED_CARD_SUCCESS:
    case UPDATE_HOME_FEED_CARD_SUCCESS:
    case DELETE_HOME_FEED_CARD_SUCCESS:
    case CREATE_BUILDING_GUIDE_CARD_SUCCESS:
    case UPDATE_BUILDING_GUIDE_CARD_SUCCESS:
    case DELETE_BUILDING_GUIDE_CARD_SUCCESS:
      return {
        ...state,
        apiError: action.error && !action.isForm ? action?.payload?.msg : null, // workaround for old code - TODO - refactor it (same below)
        success: action.error
          ? null
          : { msg: action.successMessage || i18n.t('notifications.success') },
      };
    case STAFF_CREATE_REQUESTED: {
      // Create requests must have created:true to return a notification
      let success = null;
      if (!action.error && get(action, 'payload.data.created')) {
        success = {
          msg: action.successMessage || i18n.t('notifications.success'),
        };
      }

      return {
        ...state,
        apiError: action.error && !action.isForm ? action?.payload?.msg : null,
        success,
      };
    }
    case PERSON_INVITE_RESENT:
    case ADMIN_INVITE_RESENT:
      return {
        ...state,
        error: action?.payload?.code === 1301 ? action?.payload?.msg : null,
        apiError: action.error ? action?.payload?.msg : null,
        success: action.error
          ? null
          : { msg: action.successMessage || i18n.t('notifications.success') },
      };
    case SYNC_RESIDENTS_FROM_YARDI_FAILURE: {
      const message = action?.message
        ? action.message
        : action?.err?.response?.data?.msg ?? i18n.t('notifications.wrong');
      return {
        ...state,
        apiError: message,
        success: null,
      };
    }

    case SR_CATEGORIES_UPDATE_FAILURE:
    case SR_CATEGORIES_CREATE_FAILURE:
    case SR_CATEGORIES_DELETE_FAILURE:
    case LOGIN_FAILURE:
    case FORGOT_PASSWORD_FAILURE:
    case UPDATE_NEW_VISITOR_FAILURE:
    case SET_NEW_VISITOR_FAILURE:
    case EXPIRE_VISITORS_FAILURE:
    case GET_CHATS_FAILURE:
    case GET_CHAT_BY_ID_FAILURE:
    case MARK_CHAT_AS_READ_FAILURE:
    case PUT_NEW_MESSAGE_FAILURE:
    case GET_RECIPIENTS_FAILURE:
    case CREATE_THREAD_FAILURE:
    case GET_NUMBER_OF_RECIPIENTS_FAILURE:
    case GET_ROLES_FAILURE:
    case ACCESS_POINT_UPDATE_FAILURE:
    case ACCESS_POINT_CREATE_FAILURE:
    case DOOR_UPDATE_FAILURE:
    case DOOR_CREATE_FAILURE:
    case BUILDING_CREATE_FAILURE:
    case BUILDING_UPDATE_FAILURE:
    case SYNC_PERSON_WITH_BRIVO_FAILURE:
    case CREATE_DIRECTORY_FAILURE:
    case UPDATE_DIRECTORY_FAILURE:
    case UPLOAD_FILE_FAILURE:
    case DELETE_DIRECTORY_FAILURE:
    case DELETE_FILE_FAILURE:
    case VALIDATE_ADDRESS_FAILURE:
    case PMC_UPDATE_FAILURE:
    case PMC_CREATE_FAILURE:
    case DELETE_PMC_FAILURE:
    case RESEND_INVITE_TO_ALL_RESIDENTS_FAILURE:
    case UPDATE_INVITE_INFO_FAILURE:
    case PRELOAD_DOCUMENT_FAILURE:
    case CHECK_DOCUMENT_NEW_THREAD_FAILURE:
    case CHECK_DOCUMENT_EXISTING_THREAD_FAILURE:
    case PUT_BUILDING_SETTINGS_FAILURE:
    case GET_BUILDING_BRIVO_SITE_ID_FAILURE:
    case ASSOCIATE_BRIVO_WITH_BUILDING_FAILURE:
    case ASSOCIATE_SMARTAIR_WITH_BUILDING_FAILURE:
    case ASSOCIATE_COMELIT_WITH_BUILDING_FAILURE:
    case ASSOCIATE_2N_WITH_BUILDING_FAILURE:
    case ASSOCIATE_BMX_WITH_BUILDING_FAILURE:
    case ASSIGN_YARDI_ACCOUNT_TO_BUILDING_FAILURE:
    case ASSIGN_MRI_ACCOUNT_TO_BUILDING_FAILURE:
    case ASSIGN_APPFOLIO_ACCOUNT_TO_BUILDING_FAILURE:
    case ASSIGN_EE_ACCOUNT_TO_BUILDING_FAILURE:
    case ASSIGN_PAYMENTS_ACCOUNT_TO_BUILDING_FAILURE:
    case BUILDING_DELETE_FAILURE:
    case REMOVE_ACCOUNTING_ACCOUNT_FAILURE:
    case REMOVE_AC_ACCOUNT_FAILURE:
    case CREATE_EXTERNAL_ACCOUNT_FAILURE:
    case UPDATE_EXTERNAL_ACCOUNT_FAILURE:
    case DELETE_EXTERNAL_ACCOUNT_FAILURE:
    case CREATE_CAMERA_FAILURE:
    case DELETE_CAMERA_FAILURE:
    case RESIDENT_CREATE_FAILURE:
    case RESIDENT_UPDATE_FAILURE:
    case CHECK_DOCUMENT_FAILURE:
    case GET_BMX_ACCESS_TOKEN_FAILURE:
    case SYNC_BMX_DOORS_FAILURE:
    case SYNC_PERSON_WITH_BMX_FAILURE:
    case SYNC_ALL_PERSONS_WITH_BMX_FAILURE:
    case UPLOAD_FILES_FAILURE:
    case CREATE_SERVICE_REQUEST_FAILURE:
    case CREATE_UNITS_FAILURE:
    case UPDATE_UNIT_FAILURE:
    case SYNC_BMX_PERSONS_FAILURE:
    case SYNC_DEVICES_FAILURE:
    case SYNC_PERSONS_FAILURE:
    case SYNC_PERSON_FAILURE:
    case SIGNUP_FAILURE:
    case SOCIAL_SIGNUP_FAILURE:
    case VERIFY_FAILURE:
    case GET_BMX_REGISTRATION_STATUS_FAILURE:
    case RESEND_BMX_INVITE_FAILURE:
    case DELETE_ACCESS_CARD_FAILURE:
    case UPDATE_ACCESS_CARD_FAILURE:
    case CREATE_ACCESS_CARD_FAILURE:
    case VALIDATE_ACCESS_CARD_FAILURE:
    case SEND_STATISTICS_FAILURE:
    case EXCHANGE_TOKEN_FAILURE:
    case PUT_INTEGRATIONS_STATUS_FAILURE:
    case PUT_BUILDING_DELIVERY_TYPES_FAILURE:
    case CREATE_DELIVERY_TYPE_FAILURE:
    case UPDATE_DELIVERY_TYPE_FAILURE:
    case REMOVE_DELIVERY_TYPE_FAILURE:
    case RESIDENT_MOVE_OUT_FAILURE:
    case SET_SKIP_MOVE_IN_FAILURE:
    case SUBMIT_LEASING_MESSAGE_FAILURE:
    case RESERVE_AMENITY_FAILURE:
    case CREATE_AMENITY_FAILURE:
    case UPDATE_AMENITY_FAILURE:
    case REMOVE_RESERVATION_FAILURE:
    case UPDATE_AMENITY_RESERVATION_FAILURE:
    case REMOVE_AMENITY_FAILURE:
    case DELETE_AMENITY_IMAGE_FAILURE:
    case WIPE_PERSON_DATA_FAILURE:
    case MANAGE_CREDENTIALS_FAILURE:
    case ASSOCIATE_DORMAKABA_WITH_BUILDING_FAILURE:
    case ASSOCIATE_LYAZON_WITH_BUILDING_FAILURE:
    case ASSOCIATE_ZERV_WITH_BUILDING_FAILURE:
    case ASSOCIATE_KEYSCAN_WITH_BUILDING_FAILURE:
    case ASSOCIATE_SALTO_WITH_BUILDING_FAILURE:
    case CLEAR_BRIVO_USERS_FAILURE:
    case PUT_PROPERTY_SETTINGS_FAILURE:
    case PUT_LEASING_SETTINGS_FAILURE:
    case PUT_REMOTE_DOORMAN_SETTINGS_FAILURE:
    case ON_DOOR_SCHEDULE_CHANGE_FAILURE:
    case LOG_VISITOR_ENTRY_FAILURE:
    case TOGGLE_LOGO_DISABLED_FAILURE:
    case DELETE_LOGO_FAILURE:
    case CREATE_ANNOUNCEMENT_FAILURE:
    case UPDATE_ANNOUNCEMENT_FAILURE:
    case DELETE_ANNOUNCEMENT_FAILURE:
    case SEND_ANNOUNCEMENT_FAILURE:
    case UPDATE_ACCOUNTING_ACCOUNT_FAILURE:
    case DOOR_DELETE_FAILURE:
    case SYNC_DORMAKABA_FAILURE:
    case UPDATE_BUILDING_OPERATIONS_FAILURE:
    case DELETE_PICTURE_FAILURE:
    case UPDATE_COMMUNITY_FAILURE:
    case UPDATE_COMMUNITY_ITEM_STATUS_FAILURE:
    case TOGGLE_POST_LIKE_FAILURE:
    case UPDATE_ROLE_FAILURE:
    case CREATE_CALL_CENTER_AGENT_FAILURE:
    case DELETE_CALL_CENTER_AGENT_FAILURE:
    case MODIFY_BUILDING_EXTERNAL_LINK_FAILURE:
    case MODIFY_BUILDING_EXTERNAL_LINKS_FAILURE:
    case CREATE_POP_UP_FAILURE:
    case UPDATE_POP_UP_FAILURE:
    case DELETE_POP_UP_PHOTO_FAILURE:
    case DELETE_POP_UP_FAILURE:
    case UPDATE_RD_DOORS_FAILURE:
    case CREATE_DELIVERY_FAILURE:
    case REMOVE_POST_FAILURE:
    case REMOVE_COMMENT_FAILURE:
    case SUBMIT_POST_FAILURE:
    case ADD_MESSAGE_SELLER_FAILURE:
    case CREATE_POST_COMMENT_FAILURE:
    case DELIVERIES_SIGN_OUT_FAILURE:
    case GET_DOCUMENT_FAILURE:
    case CREATE_COURIER_ERROR_FAILURE:
    case COMMUNITY_THREAD_EXISTS_FAILURE:
    case COMMUNITY_OPT_IN_OUT_FAILURE:
    case GET_POSTS_COMMENTS_LIST_FAILURE:
    case GET_POST_BY_ID_FAILURE:
    case GET_POSTS_LIST_FAILURE:
    case GET_COMMUNITY_MEMBERS_LIST_FAILURE:
    case GET_COMMUNITY_MEMBERS_LIST_FOR_FILTER_FAILURE:
    case BAN_MEMBER_FAILURE:
    case GET_COMMUNITY_CHAT_BY_ID_FAILURE:
    case GET_QR_CODE_FAILURE:
    case VERIFY_PHONE_NUMBER_FAILURE:
    case UPDATE_DELIVERY_FAILURE:
    case CREATE_STAFF_LOG_POST_FAILURE:
    case REMOVE_STAFF_LOG_POST_FAILURE:
    case CREATE_STAFF_LOG_COMMENT_FAILURE:
    case GET_STAFF_LOG_COMMENTS_LIST_FAILURE:
    case REMOVE_STAFF_LOG_COMMENT_FAILURE:
    case SET_AMENITY_STATUS_FAILURE:
    case SYNC_YARDI_SR_AND_RESIDENTS_FAILURE:
    case GET_YARDI_UNITS_FAILURE:
    case GET_YARDI_STATUSES_FAILURE:
    case SYNC_YARDI_SR_CATEGORIES_FAILURE:
    case GET_TWILIO_TOKEN_FAILURE:
    case GET_FD_RESERVATIONS_FAILURE:
    case GET_DETAILED_FD_RESERVATIONS_FAILURE:
    case GET_FD_EVENTS_FAILURE:
    case CREATE_EVENT_FAILURE:
    case UPDATE_EVENT_FAILURE:
    case DELETE_EVENT_FAILURE:
    case DELETE_EVENT_RSVP_FAILURE:
    case DELETE_EVENT_RSVP_GUEST_FAILURE:
    case CREATE_RSVP_FAILURE:
    case ADD_RSVP_GUEST_FAILURE:
    case CREATE_HOME_FEED_CARD_FAILURE:
    case UPDATE_HOME_FEED_CARD_FAILURE:
    case DELETE_HOME_FEED_CARD_FAILURE:
    case CREATE_BUILDING_GUIDE_CARD_FAILURE:
    case UPDATE_BUILDING_GUIDE_CARD_FAILURE:
    case DELETE_BUILDING_GUIDE_CARD_FAILURE:
      return {
        ...state,
        apiError:
          action?.err?.response?.data?.msg ?? i18n.t('notifications.wrong'),
        success: action.err
          ? null
          : { msg: action.successMessage || i18n.t('notifications.success') },
      };

    default:
      return state;
  }
};
